module.exports = __webpack_public_path__ + "static/save-time-money-using-shuttleid-466af284fc90043629396e98c9f63f26.jpg";